module.exports = __webpack_public_path__ + "static/img/介绍_3.1f32fd56.jpg";